import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { TableCell, TableRow } from '@mui/material';

import OnEditIcon from '../../../../icons/OnEditIcon';
import { reverseFormatDate } from '../../../../utils/dateFunctions';
import { QUALITY, SUPERUSER } from '../../../../utils/userRoles';

import table from '../../../../commonStyles/tables.module.css';
import local from './jobReadiness.module.css';

const _ACCEPTED_EDIT_ROLES = [QUALITY, SUPERUSER];

const JobReadinessTableRow = ({ jobReadinessEntry, onEdit }) => {
    // STORE STATE
    const roles = useSelector((state) => state.entities.userService.loggedInUser.roles);

    // RENDER
    return (
        <TableRow
            hover
            className={table.basicRowStripes}
            key={jobReadinessEntry.id}
            data-testid={`table-row-${jobReadinessEntry.id}`}>
            <TableCell>
                <span className={local.alignCol}>{jobReadinessEntry.jobReadiness}</span>
            </TableCell>
            <TableCell>{jobReadinessEntry.jobReadinessReason}</TableCell>
            <TableCell>{reverseFormatDate(jobReadinessEntry.createdDate)}</TableCell>
            <TableCell>{jobReadinessEntry.user}</TableCell>
            <TableCell>
                <OnEditIcon
                    onEdit={() => onEdit(jobReadinessEntry)}
                    roles={roles}
                    acceptedRoles={_ACCEPTED_EDIT_ROLES}
                />
            </TableCell>
        </TableRow>
    );
};

JobReadinessTableRow.propTypes = {
    jobReadinessEntry: PropTypes.object.isRequired,
    onEdit: PropTypes.func.isRequired
};

export default JobReadinessTableRow;
